import { isNull } from 'lodash-es'

import { formatDate } from '@/shared/lib'

export const getDiffDayText = (toDateDiffDays: number | null) => {
  if (isNull(toDateDiffDays) || toDateDiffDays === 0) {
    return '입주일 당일 이후 취소 시'
  }

  return `입주일 ${toDateDiffDays}일 이전 취소 시`
}

export const getDiffDateText = (
  fromDate: string | null,
  toDate: string | null,
) => {
  if (isNull(toDate)) {
    return `(${formatDate({ date: fromDate!, format: 'yyyy. MM. dd' })} 0시 이후)`
  }

  return `(${formatDate({ date: toDate, format: 'yyyy. MM. dd' })} 까지)`
}

export const getPenaltyText = (
  penalty: number | null,
  isOldRefundTerms: boolean,
) => {
  if (penalty === 0) {
    return '무료 취소'
  }

  if (isNull(penalty)) {
    return '취소 불가'
  }

  if (isOldRefundTerms) {
    return `임대료의 ${penalty}%`
  }

  return `임대료와 계약 수수료의 ${penalty}%`
}
